'use client';
/** @jsxImportSource @emotion/react */

import type { LocalizationProviderProps } from '@mui/x-date-pickers-pro';

import { LocalizationProvider as MuiLocalizationProvider } from '@mui/x-date-pickers-pro';

export type { LocalizationProviderProps };
export const LocalizationProvider = MuiLocalizationProvider;
